import React from 'react'

import { useFiltersContext } from '@contexts/FilterContext'

import Filter from '@components/Filter'
import Sort from '@components/Sort'

import styles from './styles.module.css'

const Filters = () => {
  const { showFilters } = useFiltersContext()

  return (
    <div className={styles.filters} data-show-filters={showFilters}>
      <section>
        <h2>Sort By</h2>
        <Sort />
      </section>

      <section>
        <h2>Filter By</h2>
        <div className={styles.filterInputs}>
          <Filter.Search />
          <Filter.Fcp />
          <Filter.Countries />
          <Filter.Categories />
          <Filter.Dates />
        </div>
      </section>

      <Filter.Reset />
    </div>
  )
}

export default Filters
